import React from "react";

const RuContent = () => {
  return (
    <div>
      <h1>Content in russian</h1>
    </div>
  );
};

export default RuContent;
